import { mapGetters, mapActions, mapState } from 'vuex';
import { isNullOrUndefined } from "util";
import http from '@/plugins/http.js'
export default {
    name: "DocumentManagerMixin",
    computed:{
        ...mapGetters("getModule",["withFilter"]),
        ...mapState("postModule",["response"]),
      },
    methods: {
        ...mapActions("postModule",['UpdateAllItems']), 
        documentManagerGridToolBarClick(e) {
            let self = this;
            let selectedRowCount = 0;
            let grid = $("#DocumentManagerGrid").data("kendoGrid");
            //let loader;
            if (e.id === "btnRefresh") {
                grid.dataSource.read();
            } else if (e.id === "btnDownloadZip") {

                let zipFilename = "Documents.zip";
                let urls = [
                    // 'https://tts-analytics.ey.com/sites/TishmanSpeyer/Workbook/Test.txt',
                    // 'https://tts-analytics.ey.com/sites/TishmanSpeyer/Workbook/Partner123.xlsx',
                ];
                grid.select().each(function () {
                    selectedRowCount++;
                    urls.push(grid.dataItem(this).FileServerRelativeUrl);
                });
                if (selectedRowCount > 0) {
                    //let blobResponses=[];
                    this._ConfirmationPopup(`Are You Sure To Download ${selectedRowCount} Files ? This Might Take Some Time!`, "default").then(response => {
                        if (response.value) {
                            this._downloadFilesZip(urls, zipFilename);
                        }
                    })

                } else {
                    this._AlertPopup("Please select atleast one row", "info");
                }
            } else if (e.id === "btnBulkDelete") {
                //alert(Bulk Delete Clicked)
                //TODO Read All the Rows to be deleted.
                //Call the Bulk Delete API with input as Array of Objects containg FileServerUrl

                let filesToBeDeleted = []

                grid.select().each(function () {
                    selectedRowCount++;
                    //each url should be inside an object
                    let file = {}
                    file.FileServerRelativeUrl = grid.dataItem(this).FileServerRelativeUrl;
                    file.FileName = grid.dataItem(this).FileName;
                    file.Id = grid.dataItem(this).Id;
                    filesToBeDeleted.push(file);
                });

                if (selectedRowCount > 0) {

                    this._ConfirmationPopup("Are You Sure To Delete All The Selected Files?", "default").then(response => {
                        if (response.value) {
                            //delete files
                            //loader = this.$loading.show();
                            this._APICrudPopup("APICrudpopup");
                            this.DeleteAllFiles(filesToBeDeleted).then(response => {
                                console.log(response);
                                //Read Details from the response whether failed or success and notify user.
                                //refresh the grid
                                grid.dataSource.read();
                                this._AlertPopup("Selected Files Were Deleted ", "info");
                            }).catch(error=>{
                                this._AlertPopup("Some Error Occurred!", "info");
                            }).finally(() => {
                                //loader.hide();
                            })
                        }
                    })

                } else {
                    this._AlertPopup("Please select atleast one row", "info");
                }

            } else if (e.id == "btnUploadNewDocuments") {
                //Route to Document Upload Page
                this.$router.push("/admin/upload");
            }
            self._baseToolBarEvents("DocumentManagerGrid", ...arguments);
        },
        actionChanged(option, id) {
            //let loader;
            //TODO
            //Get the row details from the passed in id fro the kendo grid
            let grid = $("#DocumentManagerGrid").data("kendoGrid");
            let data = grid.dataSource.data();
            let rowData = $.grep(data, function (d) {
                return d.Id == id;
            });
            let row = grid.tbody.find("tr[data-uid='" + rowData[0].uid + "']");
            //console.log(rowData);

            switch (option) {
                case "Edit":
                    //alert("Edit Item with Id : " + id);
                    grid.editRow(row);
                    break;

                case "Delete":
                    //alert("Delete Item with Id : " + id);
                    //Read details from row
                    this._ConfirmationPopup("Are You Sure To Delete The Selected Document? ", "confirm").then(response => {
                        if (response.value) {
                            //loader = this.$loading.show();
                            this._APICrudPopup("APICrudpopup");
                            let document = rowData[0];
                            //Call Delete API
                            this.DeleteFile(document).then(response => {
                                console.log(response);
                                //Read Details from the response whether failed or success and notify user.
        
                                //refresh the grid
                                grid.dataSource.read();
                                this._AlertPopup("Selected File was Deleted ", "info");
                            }).catch(error=>{
                                this._AlertPopup("Some Error Occurred!","info");
                            }).finally(() => {
                                //loader.hide();
                            })
                        }
                    })

                    break;

              
                case "Save":
                    //alert("Save Item with Id : " + id);
                    //Read details from row
                    //loader = this.$loading.show();
                    this._APICrudPopup("APICrudpopup");
                    let updatedDocument = rowData[0];
                    //updatedDocument.EntityId = this.getEntityId(updatedDocument.EntityTitle);
                    //Call Save/Update API
                    let ItemToUpdate = { list: this.documentManagerGridConfig, payload: updatedDocument };
                    this.UpdateItems(ItemToUpdate).then(response => {
                        console.log(response);
                        //need condition check for success or failure
                        //if (response.Id) {
                        //alert("Document Details Updated Successfully")
                        grid.dataSource.read();
                        this._AlertPopup("Saved Successfully", "info");
                        //}
                    }).catch(error=>{
                        this._AlertPopup("Some Error Occurred!","info");
                    }).finally(() => {
                        //loader.hide();
                    })
                    break;

                case "Cancel":
                    //alert("Cancel Item with Id : " + id);
                    //grid.cancelRow(row);
                    grid.cancelRow(row);
                    grid.dataSource.fetch();
                    break;

                case "Download":
                    //alert("Download Item with Id : " + id);
                    //window.open(process.env.VUE_APP_baseUrl + rowData[0].FileServerRelativeUrl);
                    this._downloadFile(rowData[0].FileServerRelativeUrl);

                    break;

                default:
                    break;
            }
        },
        dropZoneGridDataBound(e) {

            let grid = $("#dropZoneGrid").data("kendoGrid");
            grid.tbody.find('tr').each(function () {
                let dataItem = grid.dataItem(this);
                if (dataItem.Status == 'success') {
                    $(this).addClass('disableRow');
                }
            })
        },
        resetDropZoneGrid(e) {
            this.Files = [];
            this.count = 1;
        },
        ResetGrid() {
            this._ConfirmationPopup("This Will Reset All The Files in the Grid! \n Are You Sure? ", "Confirm")
                .then(response => {
                    if (response.value) {
                        this.resetDropZoneGrid();
                    }
                })
        },
        getCurrentDataFromGrid(gridId) {
            let grid = $("#" + gridId).data("kendoGrid");
            let gridDataArray = [];
            let gridData = grid.dataSource.data();
            for (let i = 0; i < gridData.length; i++) {
                const element = gridData[i];
                gridDataArray.push(element);
            }
            return gridDataArray;
        },
        DeleteGridRows(grid, selectedFileCount) {
            let self = this;
            // 1. Get the Updated Data from the Grid
            let currentGridDataArray = this.getCurrentDataFromGrid("dropZoneGrid");

            console.log(currentGridDataArray);

            // 2. Remove the Files Which User Wants to Delete by the Id and Selection

            grid.select().each(function () {
                console.log(grid.dataItem(this));
                let selectedRowId = grid.dataItem(this).Id;
                //console.log(selectedRowId))

                let index = currentGridDataArray.findIndex(
                    p => p.Id == selectedRowId
                );
                if (index >= 0) {
                    currentGridDataArray.splice(index, 1);
                }
                self.Files = currentGridDataArray;
                selectedFileCount++;
            });
            if (selectedFileCount <= 0) {
                this._AlertPopup("Please select atleast one file", "info")
            }
        },
        async UploadFilesToDB(flgSelected, selectedFileCount, FileUpload,invalidFileName, dropzone,uploadType,batchConfig,parentGridId) {
          
          console.log(`DocMgrMixin.UploadFilesToDB running`);
            let self = this;
            let AdminDropZoneMessage = "Please fill DocumentType and Document Level for Filename(s): "
            let BaseDropZoneMessage = "Please select the Document Type for Filename(s): "
            if (!flgSelected) {
                this._AlertPopup((dropzone == "AdminDropZone") ? AdminDropZoneMessage : BaseDropZoneMessage +
                    invalidFileName.substring(0, invalidFileName.length - 2), "info"
                );
            } else if (selectedFileCount > 0) {
                //console.log(FileUpload);
                if (FileUpload.length >= 1) {
                    //let loader = this.$loading.show();
                    this._APICrudPopup("APICrudpopup");
                    //window.$("#docModal").modal("toggle");
                    console.log("FileUpload Content")
                    console.log(FileUpload)
                    // below commented to check the file status in dev
                    //Vuex Changes
                    if (uploadType=="batch") {
                        //Update Batch Id for All Transaction Records
                        let response=await self.UpdateAllItems(batchConfig);
                        if (response && !isNullOrUndefined(parentGridId)) {
                            console.log("All Items Updated with doc Id",parentGridId);
                            $("#"+parentGridId).data("kendoGrid").dataSource.read();
                        }
                        // self.UpdateAllItems(batchConfig).then(response => {  
                        //     console.log("All Items Updated",parentGridId)      
                        //     $("#"+parentGridId).data("kendoGrid").dataSource.read();
                        //   });
                    }

                    let FilesToUpload = { config: this.dropZoneGridConfig, aryFileMetadata: FileUpload };
                    
                    self.PostAllFilesAndUpdateMetadata(FilesToUpload).then(function (responseArray) {
                        // 1. Get the grid data which user might have modified
                        let currentGridDataArray = self.getCurrentDataFromGrid(
                            "dropZoneGrid"
                        );

                        // 2. filter the selected file to be
                        responseArray.forEach(uploadObj => {
                            let index = currentGridDataArray.findIndex(
                                obj => obj.Id == uploadObj.Id
                            );

                            if (index >= 0) {
                                currentGridDataArray[index].Status = uploadObj.status;
                            }
                        });
                        self.Files = currentGridDataArray;
                        console.log(self.Files);
                        //console.log("output of files:");
                        console.log(responseArray);
                        //Once the Upload is successfull Reload the Manager Grid with the Latest Data
                        if (dropzone == "BaseDropZone") {
                            $("#DocumentManagerGrid").data("kendoGrid").dataSource.read();
                        }

                    }).finally(() => {
                        //loader.hide();
                        self.$swal.close();
                        //window.$("#docModal").modal("toggle");
                    })
                }
            } else {
                this._AlertPopup("Please select atleast one file", "info")
            }

        },
        async UploadBulkAditFilesToDBoLD(FileUpload,closePopup=false) {
            let self = this;

                    console.log(`UPLOADBULKADITFILESTODB  FileUpload=`,FileUpload);
                    let FilesToUpload = { config: this.bulkUploadAuditConfig, aryFileMetadata: FileUpload };
                    let tkn = null;
                    let isValid = this.$store.getters['authModule/apiTokenIsValid'];
                    if (isValid) {
                    tkn = this.$store.getters['authModule/api_idtoken'];
                    
                    } else {
                    // User() will try to silently get a new token  
                    this.auth.user(false)
                    .then(function(resp){
                        if (resp) {
                            console.log('was able to get a new token silently');
                            tkn = resp.apiIdToken;
                        }
                    });
                }
                    const formData = new FormData();
                    formData.append('file', FileUpload[0].File);
                    formData.append('fileInfo',FileUpload[0].FileContent);
                    formData.append('uploadType',FileUpload[0].BulkUploadType)
                    let theurl = `${process.env.VUE_APP_siteUrl}/api/${this.bulkUploadAuditConfig.list}`;
                  
                    console.log('GOING TO POST FILE 1st TIME TO CREATE TEMP FILE.... ')
                    vm.$http.post(theurl, formData, 
                    {
                       headers: {
                            'Authorization': `Bearer ${tkn}`,
                            'Content-Type': `multipart/form-data`
                        }
                    })                        
                    .then(function(postresp){
                        console.log('POSTRESPONSE: ',postresp);
                         return postresp;
                      }).catch((error) => {
                         console.log(error.response.data); 
                      })
                      .finally(function() {
                        //loader.hide();
                        if(!closePopup)
                        {
                            self.$swal.close();
                        }
                        //window.$("#docModal").modal("toggle");
                    });
                
        },
        async UploadBulkAditFilesToDB(FileUpload,closePopup=false) {
            let self = this;
            let FilesToUpload = { config: this.bulkUploadAuditConfig, aryFileMetadata: FileUpload };
            self.PostAllAuditFilesAndUpdateMetadata(FilesToUpload).then(function (responseArray) {
                console.log('responseArray:',responseArray);
                return responseArray;
            }).finally(() => {
                //loader.hide();
                if(!closePopup)
                {
                    self.$swal.close();
                }
                //window.$("#docModal").modal("toggle");
            })

                
        },
        async CompleteAuditFilePost(FileUpload,closePopup=false, uploadType) {
            let self = this;

                    console.log(`UPLOADBULKADITFILESTODB  FileUpload=`,FileUpload);
                    let FilesToUpload = { config: this.bulkUploadAuditConfig, aryFileMetadata: FileUpload };
                    apiUtil._postFileAndUpdateMetadata(FileUpload,closePopup)
                    .then(function (responseArray) {
                        return responseArray;


                        
                    }).finally(() => {
                        //loader.hide();
                        if(!closePopup)
                        {
                            self.$swal.close();
                        }
                        //window.$("#docModal").modal("toggle");
                    })
        },
        getInputControls(dropzone) {
            const self = this;
            let response = self.getLocalInputControls(self.BaseModelInputControl.list);
            
            if (dropzone =="AdminDropZone") {
                this.dropdownOptions["DocumentType"] = response["DocumentType"];
            }else{
                this.fileUploadGridOptions["DocumentType"] = response["DocumentType"];
                this.mgrGridOptions["DocumentType"] = response["DocumentType"];
            }
            
          },
    }
}